import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import ErrUnExpected from './UnExpected';
import logger from 'shared/logger';
const log = logger().child({
  namespace: 'error'
});
export default function Err500(t0) {
  const $ = _c(2);
  const {
    error
  } = t0;
  log.error(error.message);
  let t1;
  if ($[0] !== error) {
    t1 = <ErrUnExpected error={error} hasDashboardFrame={false} />;
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}